export default "__VITE_ASSET__C2Z8sXtE__"